<app-teranet-no-pin
	*ngIf="!((parentPins$ | async)?.length > 0)"
></app-teranet-no-pin>

<div
	class="flex flex-1 flex-col gap-7"
	*ngIf="(parentPins$ | async)?.length > 0"
>
	<app-teranet-pin-view
		[isOverview]="true"
		[showSimilarNames]="true"
	></app-teranet-pin-view>

	<app-teranet-instruments class="mt-2"></app-teranet-instruments>

	<app-adjacent-properties-map [showBackButton]="false" />

	<div *ngIf="selectedPin?.parcels?.length > 0" class="mt-10">
		<div
			class="mb-5 border-b flex flex-1 justify-between cursor-pointer"
			(click)="showNotes = !showNotes"
		>
			<h4 class="mr-2">Notes | PIN: {{ selectedPin.pin }}</h4>
			<app-icon *ngIf="!showNotes" [icon]="ICON.DOWN"></app-icon>
			<app-icon *ngIf="showNotes" [icon]="ICON.UP"></app-icon>
		</div>
		<div class="border rounded-md" *ngIf="showNotes">
			<div
				*ngFor="let note of selectedPin.parcels[0].notes"
				class="py-2 border-b px-5"
			>
				{{ note.toLowerCase() }}
			</div>
		</div>
	</div>
</div>
